
var myExtObject = (function () {    
    return {            
        NavigateUrlInNewTab: function (url) {            
            var pathUrl = location.protocol+"//"+location.hostname;
             if(location.port)
                 pathUrl += ":"+location.port;
            pathUrl += "/#/"+url;
            pathUrl += "&ApplicationParallelWorkflow=true";
            pathUrl += "&WindowId="+new Date().getTime();

            window.open(pathUrl, '_blank','width=1200,height=800');
        },
        DispatchEvents: function(){
            console.log("External script called");
            var  eventName = "custom-event";
            var ev;
            if(typeof(Event) === 'function') {
                ev = new Event(eventName);                
                
            }else{
                ev = document.createEvent('Event');
                ev.initEvent(eventName, true, true);
            }
            ev.detail = {Attr1:"ddd",Attr2:"dddddddddssad"};
            window.dispatchEvent(ev);
        },
        APIUrl: baseUrl
    }    
})(myExtObject || {})